import React, { Suspense } from 'react';
import serverData from './utils/server-data';
import USRoutes from './screens/US';
import GBRoutes from './screens/GB';
import { ThemeProvider } from '@paypalcorp/pp-react';
import { TENANT } from './constants';
import { LoadingScreen } from './screens/Venmo/components/LoadingScreen';
const Venmo = React.lazy(() => import('./screens/Venmo'));

function App() {
    if (serverData.tenant === TENANT.VENMO) {
        return (
            <Suspense fallback={<LoadingScreen />}>
                <Venmo />
            </Suspense>
        );
    }

    if (serverData.locality?.country === 'GB') {
        return (
            <ThemeProvider theme="v2">
                <GBRoutes />
            </ThemeProvider>
        );
    }

    return <USRoutes />;
}

export default App;
